<template>
  <div class="rechargeheader">
    <div class="recharge_leftHeader">
      <img src="../assets/img/admin_dnsd.png">
      <p>
        <span>帐户名：{{phone}}&nbsp;&nbsp;<el-button type="danger" size="small" @click="signIn">签到</el-button></span>
        <!--未认证类名:certi_qqNot certi_phoneNot certi_emailNot 已认证类名:certi_qq certi_phone certi_email-->

        <span>
          信息认证：
          <small class="certi_qqNot"></small>
          <small class="certi_phoneNot"></small>
          <small class="certi_emailNot"></small>
        </span>
      </p>
      <span>上次登录时间：{{time}}</span>
    </div>
    <p class="change_pic"></p>
    <hr>
    <!--<div class="recharge_leftBody">
      <p>
        <span>资产总计</span>
        <span>
          可用资金：
          <small>{{cash}}</small>元
        </span>
        <span>
          冻结资金：
          <small>{{frozen}}</small>元
        </span>
        <router-link class="recharge" to="/myaccount/rechange/authentication">充值</router-link>
      </p>
      <p style="margin-top: 13px;">
        <span style="color: #cd423d;font-size: 27px;">
          {{total}}
          <span style="font-size: 19px;">元</span>
        </span>
        <span>
          证券市值：
          <small>{{market}}</small>元
        </span>
        <span>
          冻结保证金：
          <small>{{bond}}</small>元
        </span>
        <router-link class="forward" to="/myaccount/rechange/putforward">提现</router-link>
      </p>
      <span class="re_line"></span>
    </div>-->
    <div class="userInfo">
      <el-row>
        <el-col :span="6" >
          <div class="userLeft">
            <h2>资产总计</h2>
            <p class="red">{{total}}</p>
            <br><br>
            <router-link to="/myaccount/rechange/authentication">
              <el-button type="danger" >充值</el-button>
            </router-link>
            <router-link to="/myaccount/rechange/putforward">
              <el-button type="primary">提现</el-button>
            </router-link>
            <router-link to="/myaccount/rechange/putforward">
              <el-button type="warning">划转</el-button>
            </router-link>
          </div>

        </el-col>
        <el-col :span="4" :offset="1">
          <h3>可用资金<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
          <p class="red">{{cash}}</p>
          <br><br>
          <h3>总配资金额<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
          <p class="red">{{cash}}</p>
        </el-col>
        <el-col :span="4">
          <h3>总冻结保证金</h3>
          <p class="red">{{bond}}</p>
          <br><br>
          <h3>总证券市值<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
          <p class="red">{{market}}</p>
        </el-col>
        <el-col :span="4">
          <h3>代金券<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
          <p class="red">{{voucher_management}}</p>
          <br><br>
          <h3>总浮动盈亏</h3>
          <p class="red">{{market}}</p>
        </el-col>
        <el-col :span="4">
          <h3>代理佣金<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
          <p class="red">{{agent_account}}</p>
          <br><br>
          <h3>总冻结资金</h3>
          <p class="red">{{frozen}}</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "Rechargeheader",
  data() {
    return {
      bond: "0.00",
      cash: "0.00",
      frozen: "0.00",
      market: "0.00",
      phone: "",
      total: "0.00",
      time: "",
      agent_account:"0.00",
      voucher_management:"0.00"
    };
  },
  mounted: function() {
    this.getUserinfo();
  },
  methods: {
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.bond = res.data.data.bond;
            that.cash = res.data.data.cash;
            that.frozen = res.data.data.frozen;
            that.market = res.data.data.market;
            that.phone = res.data.data.phone;
            that.total = res.data.data.total;
            that.time = res.data.data.time;
            that.agent_account = res.data.data.agent_account;
            that.voucher_management = res.data.data.voucher_management;

          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //签到
    signIn(){
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "checkin",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: 'success'
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    }
  }
};
</script>
<style scoped>
  .userInfo{
    line-height: 30px;
    height: 500px;
  }
  .detail{
    font-size: 14px;
    font-weight: normal;
  }
  .userLeft{
    height: 180px;
    border-right: 1px solid #DCDFE6;
  }
</style>





// WEBPACK FOOTER //
// src/components/rechargeheader.vue